import { render, staticRenderFns } from "./MatchResultsPlayer.vue?vue&type=template&id=46cd6ef0&"
import script from "./MatchResultsPlayer.vue?vue&type=script&lang=js&"
export * from "./MatchResultsPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports